import React, { useRef } from "react";
import { Line } from "react-chartjs-2";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Button } from "@mui/material";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";

import FileDownloadIcon from '@mui/icons-material/FileDownload';

Chart.register(CategoryScale);
Chart.register(ChartDataLabels);

const LineChart = ({chartData, labelData, catLabelData, title, xLabel, yLabel, chartName, chartInfo, chartColors}) => {
  let lineChartRef = useRef(null)

  const { t } = useTranslation();

  function downloadAsImage(){
    const link = document.createElement('a');
    link.download = (chartName ? title + " - " + chartName + "-LineChart.png" : title + "-LineChart.png");
    link.href = lineChartRef.current.toBase64Image('image/png', 1);
    link.click();
  }

  const backgroundColors = chartColors ? chartColors : ["#E58C8C", "#FFDCAA", "#83E5CA", "#8CCDFF", "#FFBEF1"]
  const lineChartStats = [
    {
      fill: false,
      borderColor: backgroundColors[0],
      // borderDash: [5, 5],
      tension: 0.1,
      // pointStyle: "rect",
      pointRadius: 4,
      borderWidth: 4
    },
    {
      fill: false,
      borderColor: backgroundColors[1],
      borderDash: [5, 5],
      tension: 0.1,
      pointStyle: "rect",
      pointRadius: 7,
      borderWidth: 3
    },
    {
      fill: false,
      borderColor: backgroundColors[2],
      // borderDash: [5, 5],
      tension: 0.2,
      pointStyle: "triangle",
      pointRadius: 6,
      borderWidth: 5
    },
    {
      fill: false,
      borderColor: backgroundColors[3],
      // borderDash: [5, 5],
      tension: 0.2,
      // pointStyle: "rect",
      // pointRadius: 7,
      borderWidth: 2
    },
    {
      fill: false,
      borderColor: backgroundColors[4],
      // borderDash: [5, 5],
      tension: 0.2,
      // pointStyle: "rect",
      // pointRadius: 7,
      borderWidth: 2
    }
  ]

  const chartDataFormat = {
    labels: labelData, 
    datasets: catLabelData.map((cat, i) => {
      return {
        "label": cat,
        "data": chartData[i],
        "backgroundColor": "#fff",
        "showLine": false,  // set to true to show the line between points
        ...lineChartStats[i]
      }
    })
  };

  return (
    <>
      <div style={{display: "flex", justifyContent: "space-between", flexWrap: "wrap"}}>
        <h4 style={{color: "#dc3545"}}>{chartInfo ? chartInfo : null}</h4>
        <div style={{display: "flex", gap: "0.5rem"}}>
          <Button color="info" variant="contained" size="small" onClick={downloadAsImage}>
            {t("commonComponents.lineChart.buttonLabel_imgDownload")}
          </Button>
          <Button  color="info" variant="contained" size="small" startIcon={<FileDownloadIcon />} sx={{ placeSelf: "start" }}>
            <CSVLink 
              data={[[xLabel, ...catLabelData]].concat(labelData.map((item, i) => catLabelData.map((it, j) => [item, chartData[j][i]])[0]))} 
              // headers={headers} 
              filename={chartName ? title + " - " + chartName + "-LineChart.csv" : title + "-LineChart.csv"}
            >
              {t("commonComponents.lineChart.buttonLabel_csvDownload")}
            </CSVLink>
          </Button>
        </div>
      </div>
      <Line
        ref = {lineChartRef}
        data = {chartDataFormat}
        options = {
          {
            interaction: {
              intersect: false,
              mode: 'index',
            },
            plugins: {
              title: {
                display: true,
                // align: "start",
                text: title,
                font: {
                  family: "Poppins",
                  size: "14px",
                  // weight: "bold"
                },
              },
              legend: {
                display: true,
                labels: {
                  usePointStyle: true,
                }   
                // position: "left",
              },
              datalabels: {
                display: false
              },
              // datalabels: {
              //   color: "black",
              //   formatter: function (value, context) {
              //     if (context.chart.data.datasets[context.datasetIndex] != null) {
              //       if (value === 0) return null;
              //       return chartData[context.dataIndex][context.datasetIndex]
              //     }
              //   },
              //   events: [],
              // },
              // tooltip: {
              //   callbacks: {
              //     label: function (context) {
              //       return context.dataset.label + ": " + chartData[context.dataIndex][context.datasetIndex] + " (" + context.formattedValue + ")"
              //     },
              //     footer: function (tooltipItems) {
              //       let total = 0;
              //       tooltipItems.forEach(function(tooltipItem) {
              //         total += chartData[tooltipItem.dataIndex][tooltipItem.datasetIndex];
              //       });
              //       return 'Total: ' + total;
              //     },
              //   }
              // }
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                title: {
                  display: true,
                  text: xLabel,
                  font: {
                    family: "Poppins",
                    weight: "bold",
                    size: "14px",
                  },
                },
                // grid: {
                //   display: false
                // },
                // ticks: {
                //   color: "black",
                //   font: {
                //     size: "18px"
                //   }
                //   // maxRotation: 0,   // This controls the rotation of labels
                // }
                ticks: {
                  // maxRotation: 0,   // This controls the rotation of labels
                  // sampleSize: 1,
                }
              },
              y: {
                title: {
                  display: true,
                  text: yLabel,
                  font: {
                    family: "Poppins",
                    weight: "bold",
                    size: "14px",
                  },
                },
                // },
                // grid: {
                //   display: false
                // },
                // suggestedMin: 20,
                // suggestedMax: 180,
                ticks: {
                  // display: false,
                  // beginAtZero: true,
                  stepSize: 5,
                  // color: "black",
                  // font: {
                  //   size: "18px",
                  // }
                },
              },
            }
          }
        }
      />
    </>
  );
};

export default LineChart;